// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a {
  text-decoration: none !important;
}

.home {
  margin-top: 2rem;
}
.home .posts {
  display: flex;
  justify-content: center;
}

.posts {
  margin-top: 2rem;
  display: flex;
  justify-content: center;
}
.posts img {
  width: 100%;
  height: auto;
  margin-bottom: 3rem;
}
.posts h1 {
  margin-bottom: 1rem;
}

.loader {
  position: absolute;
  left: 40%;
  top: 50%;
}

.card {
  margin-bottom: 1rem;
}
.card .card-title {
  font-size: 1.5em;
  color: black;
}
.card .card-text {
  font-size: 1em;
  color: black;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/style.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;AACF;;AACA;EACE,gBAAA;AAEF;AADE;EACE,aAAA;EACA,uBAAA;AAGJ;;AACA;EASE,gBAAA;EACA,aAAA;EACA,uBAAA;AANF;AAJE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAMJ;AAJE;EACE,mBAAA;AAMJ;;AACA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;AAEF;;AACA;EACE,mBAAA;AAEF;AADE;EACE,gBAAA;EACA,YAAA;AAGJ;AADE;EACE,cAAA;EACA,YAAA;AAGJ","sourcesContent":["a {\n  text-decoration: none !important;\n}\n.home {\n  margin-top: 2rem;\n  .posts {\n    display: flex;\n    justify-content: center;\n  }\n}\n\n.posts {\n  img {\n    width: 100%;\n    height: auto;\n    margin-bottom: 3rem;\n  }\n  h1 {\n    margin-bottom: 1rem;\n  }\n  margin-top: 2rem;\n  display: flex;\n  justify-content: center;\n}\n\n.loader {\n  position: absolute;\n  left: 40%;\n  top: 50%;\n}\n\n.card {\n  margin-bottom: 1rem;\n  .card-title {\n    font-size: 1.5em;\n    color: black;\n  }\n  .card-text {\n    font-size: 1em;\n    color: black;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
